import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { queryClient } from './lib/queryClient.js';
import { isInService } from './lib/season.js';
import { ClosedScreen } from './components/ClosedScreen.js';
import { Layout } from './components/Layout.js';
import { MapPage } from './pages/MapPage.js';

export function App() {
  if (!isInService()) {
    return <ClosedScreen />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<MapPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
